import { screenThumb } from './thumbs';

/** How long each screen shows while a pointer rests on a card, and how long the blur hand-over takes. */
export const CYCLE_STEP_MS = 1100;
export const CYCLE_FADE_MS = 450;
/** Cards step through at most this many screens, so the progress bar stays readable. */
const CYCLE_MAX = 12;

/**
 * The screens a cover card steps through on hover: its cover first, then the screens after it in
 * recording order (wrapping round), spread evenly when there are more than fit. Only screens with
 * stored WebP copies take part, because those are the files the card can load ahead of time.
 */
export function cycleScreens(urls: Array<string | null | undefined>, cover?: string | null, max = CYCLE_MAX): string[] {
  const usable = [...new Set(urls.filter((u): u is string => Boolean(u && screenThumb(u, 400))))];
  const first = cover ?? urls[0];
  if (!first || !screenThumb(first, 400)) return [];
  const at = usable.indexOf(first);
  const rest = at < 0 ? usable : [...usable.slice(at + 1), ...usable.slice(0, at)];
  const room = Math.max(0, max - 1);
  const picked = rest.length <= room ? rest : Array.from({ length: room }, (_, i) => rest[Math.floor((i * rest.length) / room)]);
  return [first, ...picked];
}

/** Only a real mouse or trackpad cycles: touch keeps its tap, and reduced motion means none. */
export function canCycle(matchMedia: ((query: string) => { matches: boolean }) | undefined): boolean {
  if (!matchMedia) return false;
  return matchMedia('(hover: hover) and (pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
}
